import { z } from 'zod';
import { MoneySchema } from './common.js';
export const LoanPurposeSchema = z.enum(['SPECIFIC', 'GENERAL']);
export const LoanSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(32),
    bank: z.string().min(1),
    principal: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    // Prisma Decimal(8,4) — interest rate as a percent (e.g. 4.5000). Accept
    // either string (canonical Decimal form) or coerced number; rates can also
    // legitimately be 0 for some intra-group loans.
    rate: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    purpose: LoanPurposeSchema,
    // null when purpose === 'GENERAL'; coordinator should layer a cross-field
    // refinement at the API edge if it wants to enforce SPECIFIC -> non-null.
    tiedProjectId: z.uuid().nullable().optional(),
    // ISO date strings on the wire; services convert to Date for Prisma.
    startDate: z.iso.date(),
    endDate: z.iso.date(),
    isActive: z.boolean(),
    branchId: z.uuid().nullable().optional(),
    departmentId: z.uuid().nullable().optional(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateLoanSchema = LoanSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateLoanSchema = CreateLoanSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=loan.js.map